import { AlertCircle } from "lucide-react"
import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Button, Card, Input } from "../components/ui"
import { useAuth } from "../contexts/AuthContext"

const RegisterPage: React.FC = () => {
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const navigate = useNavigate()
    const { register } = useAuth()

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        if (!username || !password || !confirmPassword) {
            setError("Todos os campos são obrigatórios")
            return
        }
        if (password !== confirmPassword) {
            setError("As senhas não coincidem")
            return
        }
        if (password.length < 6) {
            setError("A senha deve ter pelo menos 6 caracteres")
            return
        }

        setLoading(true)
        setError(null)

        try {
            await register(username, password, setError, () =>
                navigate("/dashboard")
            )
        } catch (err: any) {
            setError("Falha ao registrar. Por favor, tente novamente.")
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="flex min-h-screen items-center justify-center bg-bg px-4 py-12 sm:px-6 lg:px-8">
            <div className="w-full max-w-md">
                <div className="mb-8">
                    <h2 className="text-center text-3xl font-bold text-text">
                        Criar nova conta
                    </h2>
                    <p className="mt-2 text-center text-sm text-muted">
                        Ou{" "}
                        <Link
                            to="/login"
                            className="font-medium text-primary hover:opacity-80"
                        >
                            faça login na sua conta existente
                        </Link>
                    </p>
                </div>

                {error && (
                    <div className="mb-6 flex items-start gap-3 rounded-lg border border-danger/40 bg-danger-soft p-4">
                        <AlertCircle className="h-5 w-5 flex-shrink-0 text-danger-text" />
                        <p className="text-sm font-medium text-danger-text">
                            {error}
                        </p>
                    </div>
                )}

                <Card>
                    <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                        <div>
                            <label
                                htmlFor="username"
                                className="mb-1 block text-sm font-medium text-text"
                            >
                                Nome de usuário
                            </label>
                            <Input
                                id="username"
                                name="username"
                                type="text"
                                autoComplete="username"
                                required
                                placeholder="Nome de usuário"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                disabled={loading}
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="password"
                                className="mb-1 block text-sm font-medium text-text"
                            >
                                Senha
                            </label>
                            <Input
                                id="password"
                                name="password"
                                type="password"
                                autoComplete="new-password"
                                required
                                placeholder="Senha"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                disabled={loading}
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="confirm-password"
                                className="mb-1 block text-sm font-medium text-text"
                            >
                                Confirmar senha
                            </label>
                            <Input
                                id="confirm-password"
                                name="confirm-password"
                                type="password"
                                autoComplete="new-password"
                                required
                                placeholder="Confirmar senha"
                                value={confirmPassword}
                                onChange={(e) =>
                                    setConfirmPassword(e.target.value)
                                }
                                disabled={loading}
                            />
                        </div>

                        <Button
                            type="submit"
                            loading={loading}
                            className="mt-2 w-full"
                        >
                            {loading ? "Registrando..." : "Registrar"}
                        </Button>
                    </form>
                </Card>
            </div>
        </div>
    )
}

export default RegisterPage
